export default [
    {
        name:"RetrievalWriting",
        path:"RetrievalWriting",
        component:()=>import("@/view/WebViews/Patent/RetrievalWriting"),
        meta:{
            title:"检索与撰写",
        }
    },
    {
        name:"InvalidDefense",
        path:"InvalidDefense",
        component:()=>import("@/view/WebViews/Patent/InvalidDefense"),
        meta:{
            title:"无效与答辩",
        }
    },
    {
        name:"TransferLicense",
        path:"TransferLicense",
        component:()=>import("@/view/WebViews/Patent/TransferLicense"),
        meta:{
            title:"转让与许可",
        }
    },
    {
        name:"ExcellentQuickReview",
        path:"ExcellentQuickReview",
        component:()=>import("@/view/WebViews/Patent/ExcellentQuickReview"),
        meta:{
            title:"优审与快审",
        }
    },
    {
        name:"LayoutPlanning",
        path:"LayoutPlanning",
        component:()=>import("@/view/WebViews/Patent/LayoutPlanning"),
        meta:{
            title:"布局与规划",
        }
    },
]